const columns = [
  {
    title: '内容分类',
    links: [
      { label: '短视频专区', href: '#boards' },
      { label: '直播专区', href: '#boards' },
      { label: '福利资源专区', href: '#boards' },
      { label: '话题墙', href: '#topics' },
    ],
  },
  {
    title: '找主播',
    links: [
      { label: '主播精选', href: '#anchors' },
      { label: '音乐现场', href: '#topics' },
      { label: '美食探店', href: '#topics' },
      { label: '城市漫游', href: '#topics' },
    ],
  },
  {
    title: '使用帮助',
    links: [
      { label: '近期更新', href: '#updates' },
      { label: '常见问题', href: '#faq' },
      { label: '进入热门榜', href: '#hot' },
      { label: '回到顶部', href: '#top' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-black">
                蓝
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-lg font-black text-background-50">
                  小蓝视频
                </span>
                <span className="block text-xs font-label text-background-200/70">
                  主播与热门内容浏览指南
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm font-label text-background-200/80 leading-relaxed max-w-md">
              把主播生态与热门内容集中在一页：短视频、直播、福利资源按专区铺开，先认识人，再挑内容，按图索骥不迷路。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['短视频', '直播', '福利资源', '主播精选', '热门内容'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs font-label text-background-200/90"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h3 className="font-label text-sm font-medium text-background-50 mb-4">{column.title}</h3>
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm font-label text-background-200/70 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs font-label text-background-200/60">
            本页为内容浏览指南，所有按钮与入口均为展示示意。
          </p>
          <p className="text-xs font-label text-background-200/60">
            © 2026 小蓝视频 · 内容浏览指南
          </p>
        </div>
      </div>
    </footer>
  );
}